import React, {useState} from "react";
import ResultsBiosensor from "./results_biosensor";
import ResultsDegradation from "./results_degradation";


export default function Results() {

    const [isBiosensor, setIsBiosensor] = useState(true);

    const switchPage = () => {
        setIsBiosensor(!isBiosensor);
    };

    if (isBiosensor)
        return <ResultsBiosensor switchPage={() => switchPage()}></ResultsBiosensor>
    else
        return <ResultsDegradation switchPage={() => switchPage()}></ResultsDegradation>

}